<!-- src/views/statistics/components/FeedbackDetailDialog.vue -->
<template>
  <el-dialog
    title="用户交流明细报表"
    :visible.sync="dialogVisible"
    width="1200px"
    append-to-body 
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        style="width: 280px;"
        @change="onDateChange"
      />
      
      <!--el-select v-model="filterHit" placeholder="是否命中" size="small" clearable style="width: 120px; margin-left: 12px;" @change="onSearch">
        <el-option label="全部" :value="null"></el-option>
        <el-option label="命中" :value="1"></el-option>
        <el-option label="未命中" :value="0"></el-option>
      </el-select-->
      
      <el-input
        v-model="keyword"
        placeholder="搜索问题/回答关键词"
        size="small"
        clearable
        style="width: 220px; margin-left: 12px;"
        @keyup.enter.native="onSearch"
        @clear="onSearch"
      >
        <i slot="prefix"><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="32" height="32"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i>
      </el-input>
      
      <el-button type="primary" size="small" @click="onSearch" style="margin-left: 12px;">
        <i><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="16" height="16"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i> 查询
      </el-button>
      
      <el-button size="small" @click="handleExport">
        <i><svg t="1783182461564" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2783" width="16" height="16"><path d="M469.333333 682.666667V42.666667c0-23.466667 19.2-42.666667 42.666667-42.666667s42.666667 19.2 42.666667 42.666667v640c0 23.466667-19.2 42.666667-42.666667 42.666666s-42.666667-19.2-42.666667-42.666666" fill="#bfbfbf" p-id="2784"></path><path d="M226.210133 268.0576L481.826133 12.433067a42.7776 42.7776 0 0 1 60.330667 0c16.597333 16.597333 16.597333 43.776 0 60.330666L286.5408 328.388267a42.7776 42.7776 0 0 1-60.330667 0 42.7776 42.7776 0 0 1 0-60.330667" fill="#bfbfbf" p-id="2785"></path><path d="M542.0544 12.4416l255.616 255.616a42.7776 42.7776 0 0 1 0 60.330667c-16.597333 16.605867-43.776 16.605867-60.330667 0L481.723733 72.789333a42.7776 42.7776 0 0 1 0-60.330666 42.7776 42.7776 0 0 1 60.330667 0M896 1024H128c-70.570667 0-128-57.429333-128-128V640c0-23.594667 19.072-42.666667 42.666667-42.666667s42.666667 19.072 42.666666 42.666667v256c0 23.552 19.114667 42.666667 42.666667 42.666667h768c23.552 0 42.666667-19.114667 42.666667-42.666667V640c0-23.594667 19.072-42.666667 42.666666-42.666667s42.666667 19.072 42.666667 42.666667v256c0 70.570667-57.429333 128-128 128" fill="#bfbfbf" p-id="2786"></path></svg></i> 导出

      </el-button>
      
      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 条记录
      </span>
    </div>
    
    <!-- 表格 -->
<el-table
  ref="feedbackTable"
  :data="tableData"
  v-loading="loading"
  border
  stripe
  style="width: 100%; margin-top: 12px;"
  max-height="500"
>
  <el-table-column type="index" label="序号" width="60" align="center" />
  <el-table-column prop="conversationId" label="会话ID" width="120" align="center">
    <template slot-scope="{ row }">
      <el-tag size="mini" type="info">{{ row.conversationId }}</el-tag>
    </template>
  </el-table-column>
  <el-table-column prop="userName" label="用户" width="100" align="center" />
  
  <!-- 用户提问列（手动 tooltip） -->
  <el-table-column label="用户提问" width="250" min-width="180">
    <template slot-scope="{ row }">
      <el-tooltip
        :content="row.question"
        placement="top"
        :disabled="!isOverflow"
        popper-class="custom-tooltip"
      >
        <span class="ellipsis-text">{{ row.question }}</span>
      </el-tooltip>
    </template>
  </el-table-column>
  
  <!-- AI回复列（手动 tooltip） -->
<el-table-column label="AI回复" width="300" min-width="300">
  <template slot-scope="{ row }">
    <el-tooltip
      :content="row.answer"
      placement="top"
      :disabled="!isOverflow"
      popper-class="custom-tooltip"
    >
      <span class="ellipsis-text">{{ row.answer }}</span>
    </el-tooltip>
  </template>
</el-table-column>
  
  <el-table-column prop="isHit" label="是否命中" width="90" align="center">
    <template slot-scope="{ row }">
      <el-tag :type="row.isHit === 1 ? 'success' : 'danger'" size="mini">
        {{ row.isHit === 1 ? '命中' : '未命中' }}
      </el-tag>
    </template>
  </el-table-column>
  
  <el-table-column label="命中文档" width="160" show-overflow-tooltip>
    <template slot-scope="{ row }">
         <el-tooltip
        :content="row.hitDocTitle"
        placement="top"
        :disabled="!isOverflow"
        popper-class="custom-tooltip"
      >
        <span class="ellipsis-text">{{ row.hitDocTitle }}</span>
      </el-tooltip>

    </template>
  </el-table-column>
  
  <el-table-column prop="confidence" label="置信度" width="80" align="center">
    <template slot-scope="{ row }">
      <span v-if="row.confidence !== null">{{ (row.confidence * 100).toFixed(1) }}%</span>
      <span v-else style="color: #c0c4cc;">-</span>
    </template>
  </el-table-column>
  <el-table-column prop="sourceType" label="来源" width="150" align="center">
    <template slot-scope="{ row }">
      <el-tag size="mini" type="warning" v-if="row.sourceType">{{ row.sourceType }}</el-tag>
      <span v-else style="color: #c0c4cc;">-</span>
    </template>
  </el-table-column>
  <el-table-column prop="createdAt" label="时间" width="170" align="center">
    <template slot-scope="{ row }">
      {{ row.createdAt }}
    </template>
  </el-table-column>
</el-table>
    
    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getFeedbackDetail } from '@/api/dashboard'
import { exportFeedbackDetail } from '@/api/dashboard'
 
export default {
  name: 'FeedbackDetailDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      page: 0,
      size: 20,
      dateRange: this.getDefaultDateRange(),
      filterHit: null,
      keyword: '',
      pickerOptions: {
        shortcuts: [
          { text: '近7天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }},
          { text: '近30天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }},
          { text: '近90天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }}
        ]
      }
    }
  },
  computed: {
    tenantId() {
      return this.$store.getters['auth/currentTenant']?.tenantId || null
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.page = 0
      this.dateRange = this.getDefaultDateRange()
      this.filterHit = null
      this.keyword = ''
      this.loadData()
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    getDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      return [this.formatDate(start), this.formatDate(end)]
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onDateChange() {
      this.page = 0
      this.loadData()
    },
    onSearch() {
      this.page = 0
      this.loadData()
    },
    onPageChange(page) {
      this.page = page - 1
      this.loadData()
    },
    onSizeChange(size) {
      this.size = size
      this.page = 0
      this.loadData()
    },
  isOverflow(el) {
     return el?.scrollWidth > el?.clientWidth  // 溢出时返回 true，启用 tooltip
   },    
    async handleExport() {
        this.exportLoading = true
        
        try {
          const params = {
            tenantId: this.$store.state.auth.tenantInfo.tenantId,
            startTime: this.dateRange[0],
            endTime: this.dateRange[1],
          //  isHit: this.hitFilter === 'all' ? undefined : parseInt(this.hitFilter),
            keyword: this.keyword || undefined
          }
          
          // 调用导出接口
          const response = await exportFeedbackDetail(params)
          
          // 处理文件下载
          const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          
          // 从响应头获取文件名
          const disposition = response.headers['content-disposition']
          let fileName = '用户反馈明细.xlsx'
          if (disposition) {
            const match = disposition.match(/filename=(.+)/)
            if (match) fileName = decodeURIComponent(match[1])
          }
          
          link.download = fileName
          link.click()
          URL.revokeObjectURL(link.href)
          
          this.$message.success('导出成功')
        } catch (error) {
          console.error('导出失败:', error)
          this.$message.error('导出失败，请重试')
        } finally {
          this.exportLoading = false
        }
    },
    async loadData() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }
      
      this.loading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          page: this.page,
          size: this.size,
          keyword: this.keyword || '',      // ← 传递关键词
          isHit: this.filterHit              // ← 传递命中筛选
        }
        
        const res = await getFeedbackDetail(params)
            console.log('反馈明细响应:', res)
            
            if (res?.data?.code === 200) {
              const data = res.data.data
              this.tableData = data?.content || []
              this.total = data?.total_elements || 0
              this.page = data?.pageable?.page_number || 0
            } else {
              this.$message.error(res?.data?.message || '加载失败')
              this.tableData = []
              this.total = 0
            }
          } catch (error) {
            console.error('加载反馈明细失败:', error)
            this.$message.error('加载失败: ' + (error.message || '未知错误'))
            this.tableData = []
            this.total = 0
          } finally {
              this.$nextTick(() => {
                // 强制刷新表格的 tooltip 绑定
                this.$refs.feedbackTable?.doLayout()
              })
            this.loading = false
          }
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

/* ===== 1. 只隐藏分页器里的图标（方块源头） ===== */
::v-deep .el-pagination .btn-prev .el-icon,
::v-deep .el-pagination .btn-next .el-icon,
::v-deep .el-pagination .el-icon-arrow-left,
::v-deep .el-pagination .el-icon-arrow-right {
  display: none !important;
}

/* ===== 2. 分页器左右箭头替换 ===== */
::v-deep .el-pagination .btn-prev {
  position: relative;
}
::v-deep .el-pagination .btn-prev::after {
  content: '<' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-pagination .btn-next {
  position: relative;
}
::v-deep .el-pagination .btn-next::after {
  content: '>' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

/* ===== 3. 只隐藏搜索框的清除按钮（x图标变成方块的那个） ===== */
::v-deep .el-input__clear {
  display: none !important;
}

/* ===== 4. 恢复搜索框前缀图标（放大镜） ===== */
::v-deep .el-input__prefix {
  display: flex !important;
  align-items: center !important;
  left: 5px !important;
}
.ellipsis-text {
  display: block;
  font-size: small;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-tooltip {
  z-index: 999999 !important;
}
</style>